export default {
  primary: "#3DAE2B",
  gray: "#53575A",
  grayLight: "#B1B1B1",
  grayUltraLight: "rgb(245 245 245)",
  grayFondo: "#F7F7F7",
  error: "#F53232",
  warning: "orange",
  white:'#ffffff',
  whiteTransparent: '#ffffffad',
  grayDark: '#515558',
  grayDarkOpacity: 'rgba(81, 85, 88, 0.85)',
  primaryDark: '#45A951',
  primaryOpacity: 'rgba(69, 169, 81, 0.85)',
  primaryOpacity2: 'rgba(69, 169, 81, 0.55)',
  colorPlanEspecial: '#00269A',
  colorPlanAvanzado: '#0097CE',
  colorPlanMaximo: '#FF5F00',
  colorPlanPremium: '#53575A',
  colorBlue: "#0C6EF2",
  blackTransparent: '#000000ad',
  // Ultra — negro premium
  ultraBlack: '#0a0a0a',
  ultraDark: '#111111',
  ultraMid:  '#1a1a1a',
  ultraSurface: '#252525',
  ultraBorder: 'rgba(255,255,255,0.07)',
  ultraSilver: '#b0b0b0',
  ultraWhite: '#f0f0f0',
  // Ultra — paleta acento sage (#5B6E63)
  ultraAccent: '#5B6E63',
  ultraAccentDark: '#3e4f47',
  ultraAccentLight: '#7a9085',
  ultraAccentMuted: 'rgba(91,110,99,0.18)',
  ultraAccentBorder: 'rgba(91,110,99,0.35)',
  // URL logo dinámico (público, sin token)
  ultraLogoUrl: 'https://apiovadev.arssenasa.gob.do/api/Asset/render/0e37920e-b017-4f6a-adaf-778aeb3d3744',
  // Ultra Light Mode palette (modo blanco premium)
  ulBg: '#F7F7F8',
  ulCard: '#FFFFFF',
  ulCardDark: '#1C1C1E',
  ulText: '#0D0D0D',
  ulTextSec: '#6B7280',
  ulBorder: 'rgba(0,0,0,0.09)',
  ulAccent: '#1C1C1E',
  ulAccentSoft: '#3A3A3A',
};
